import { SimplePaletteColorOptions, TypeBackground, PaletteOptions } from "@mui/material/styles";

export const primaryPalette: SimplePaletteColorOptions = {
  main: "#00338d",
  contrastText: "#ffffff",
};

export const backgroundPalette: TypeBackground = {
  default: "#efefef",
  paper: "#ffffff",
};

export const paletteOptions: PaletteOptions = {
  primary: primaryPalette,
  background: backgroundPalette,
};
